import React, {useEffect, useState} from 'react'
import {useHistory, useParams} from 'react-router-dom'
//---REDUX
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import allTheActions from '../actions'
//---
import Navbar from "../components/navbar"
import Menu from "../components/menu"
import TitleH1 from "../components/titleH1"
import TileH3 from "../components/titleH3"
import Table from "../components/table"
import check from "../assets/check.png"
import Image from "../components/image";
import ButtonForm from "../components/buttonForm";
import MenuMember from "../components/menuMember";

const ConfirmRenewal = props => {
    const [data, setData] = useState([])
    const history = useHistory()
    const params = useParams()
    const club = JSON.parse(JSON.parse(localStorage.getItem('persist:3fts')).club)

    useEffect(() => {
        const getLicences = async () => {
            setData(await JSON.parse(JSON.parse(localStorage.getItem('persist:3fts')).licence))
        }
        getLicences()
    }, [])

    if(data.length > 0 && params.type === "licence") {
        props.actions.licence.updateMultipleLicences(data, club._id)
    } else if(data.length > 0 && params.type === "club")
        props.actions.club.updateLicenceClub({id: club._id, validite: parseInt(club.validite) + 1})

    return (
        <>
            <Navbar/>
            {(localStorage.getItem('admin') === 'true') ? <Menu/> : <MenuMember/>}
            <TitleH1 content="Renouvellement confirmé !"/>
            <TileH3
                content={`Un mail récapitulatif vient de vous être envoyé à l'adresse ${localStorage.getItem('mail')}`}
            />
            <Table content={
                <tbody>
                {
                    (data.length > 0 && params.type === "licence") ?
                        data.map(info => {
                            return (
                                <tr key={info._id}>
                                    <td>{info.prenom} {info.nom}</td>
                                    <td>{info.categorie}</td>
                                    <td><Image src={check} alt="" width="50px"/></td>
                                </tr>
                            )
                        })
                        : null
                }
                </tbody>
            }
            />
            <ButtonForm onClick={() => history.push(`/club/${club._id}`)} value="<= Revenir au club"/>
        </>
    )
}

const mapStateToProps = state => ({
    licenceState: state.licence,
    clubState: state.club
})

const mapDispatchToProps = () => dispatch => ({
    actions: {
        licence: bindActionCreators(allTheActions.licence, dispatch),
        club: bindActionCreators(allTheActions.club, dispatch)
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmRenewal)
